module.exports = __webpack_public_path__ + "img/owl-purple-front.02cefe8d.png";